import { ComplianceOverviewWebComponent } from './component/ComplianceOverviewWebComponent';

export { ComplianceOverviewWebComponent };
